import "@/styles/index.css";

import form from "@/scripts/components/form/form";
import glowPoint from "@/scripts/components/glow-point";
import mediaSlider from "@/scripts/components/media-slider";
import mobileBar from "@/scripts/components/mobile-bar";
import modal from "@/scripts/components/modal";
import paginatedList from "@/scripts/components/paginated-list";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import siteHeader from "@/scripts/components/site-header";
import slideToggle from "@/scripts/components/slide-toggle";
import tooltip from "@/scripts/components/tooltip";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import { filterDropdown } from "@/scripts/alpine/filter-dropdown";
import { pillMarker } from "@/scripts/alpine/pill-marker";

form.init();
glowPoint.init();
mediaSlider.init();
mobileBar.init();
modal.init();
paginatedList.init();
scrollReveal.init();
scrollTo.init();
siteHeader.init();
slideToggle.init();
tooltip.init();

Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.data("filterDropdown", filterDropdown);
Alpine.data("pillMarker", pillMarker);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
